import { render, staticRenderFns } from "./cupsule.vue?vue&type=template&id=9bc046fa"
import script from "./cupsule.vue?vue&type=script&lang=js"
export * from "./cupsule.vue?vue&type=script&lang=js"
import style0 from "./cupsule.vue?vue&type=style&index=0&id=9bc046fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports